import axios from 'axios'
import Vue from 'vue'
import Vuex, { Store } from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    projects: []
  },
  mutations: {
    updateProjects(state, projects) {
      state.projects = projects;
    }
  },
  actions: {
    getPrismicData({commit}, prismic) {
       prismic.client.query(
        prismic.Predicates.at('document.type', 'projects')
      )
      .then ((data) => {
        this.commit('updateProjects', data.results)
      })
      .catch((error) => {
        console.log("Error fetching Projects from Prismic.io, ERROR: ", error)
      })
    }
  }
})
